import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrTravelGuideStatus.ts
var t = () => e("travelGuideStatus");
//#endregion
export { t as useTrTravelGuideStatus };
